module.exports = __webpack_public_path__ + "img/team-06.1512b183.jpg";